import React from "react";

const LIGHT = ["#F5F1E8", "#E6D9B6", "#C7E3F4", "#F4D35E"];

// Two dots = surprised eyes + two coffee beans. Bean-shaped with a central crease.
export const Eyes = ({ size = 10, color = "#121212", gap = 8, blink = false, className = "", crease }) => {
  const creaseColor = crease || (LIGHT.includes(color) ? "rgba(59,37,35,0.42)" : "rgba(245,241,232,0.5)");
  const w = size;
  const h = Math.round(size * 1.22);
  const tilts = [-8, 8];
  return (
    <span className={`inline-flex items-center ${className}`} style={{ gap }} aria-hidden="true">
      {tilts.map((tilt, i) => (
        <span key={i} style={{ display: "inline-block", transform: `rotate(${tilt}deg)`, lineHeight: 0 }}>
          <svg
            width={w}
            height={h}
            viewBox="0 0 20 25"
            className={blink ? "naguara-eye" : ""}
            style={{ animationDelay: i ? "0.08s" : "0s", display: "block" }}
          >
            <path
              d="M10 1 C15 1 19 6 19 12.5 C19 19 15 24 10 24 C5 24 1 19 1 12.5 C1 6 5 1 10 1 Z"
              fill={color}
            />
            <path
              d="M10 4.5 C8 8 12 11 10 13 C8 15 12 18 10 20.5"
              fill="none"
              stroke={creaseColor}
              strokeWidth="1.3"
              strokeLinecap="round"
            />
          </svg>
        </span>
      ))}
    </span>
  );
};

// Official approved logo (SVG, outlines). Never simulate with a font.
export const NaguaraLogo = ({ variant = "beige", width = 145, className = "" }) => (
  <img
    src={`/brand/naguara/naguara-logo-completo-${variant}.svg`}
    alt="Naguarà"
    width={width}
    height={Math.round((width * 145) / 545)}
    draggable="false"
    style={{ width, height: "auto", objectFit: "contain", display: "block" }}
    className={className}
  />
);

// Official isotype (two ovals / eyes). Secondary resource, decorative.
export const Isotipo = ({ variant = "chocolate", size = 40, className = "" }) => (
  <img
    src={`/brand/naguara/naguara-isotipo-ojos-${variant}.svg`}
    alt=""
    aria-hidden="true"
    width={size}
    height={Math.round((size * 80) / 125)}
    draggable="false"
    style={{ width: size, height: "auto", objectFit: "contain" }}
    className={className}
  />
);
